const PAYMENT_CONSTANTS = {
  PERSON: 'person',
  VEHICLE: 'vehicle',
};

export default PAYMENT_CONSTANTS;
